<template>
  <div class="yunxiao teacher stored-card-list">
    <search-filter-new
      :items="seachItems"
      :campus="params.openCampusList"
      placeholder="请输入手机号/储值卡名称"
      @onCampus="chooseCampus"
      @onSearch="params.phoneOrName = $event"
      @onAdd="gotoAddstoredCard"
    />
    <search-filter-new @change="filterChange">
      <FilterItem 
        :hasFilter="!!params.statusList.length" 
        keyName="statusList"
        :value="params.statusList"
        kind="yq-通用选择" 
        title="状态"
        :list="
        [
          { text: '启用', value: 0 },
          { text: '过期', value: 2 },
        ]" 
      />
      <sideFilterItem :hasFilter="hasFilter" @clickFilter="openFilter" />
    </search-filter-new>
    <div class="list-number-line flex-between">
      <div class="add-area__info">储值卡数量：{{ totalCount }}</div>
      <div style="color: var(--c1)" @click="$router.push({
        name: 'help-page',
        params: {
          src:'https://bangzhu.xiaogj.com/yxhelp-list/detail-139.html'
        }
      })">什么是储值卡？</div>
    </div>
    <vx-list
      enable
      :api="api"
      :params="params"
      @load="onLoad"
      ref="listScroller"
      class="wrapper"
    >
    <div v-for="(item,index) in list" :key="index" class="card-wrap" @click="$router.push(`/storedCardDetail/${item.id}`)">
      <div class="card-top flex-between">
        <div class="name">{{item.storedCardAccountName}}
          <span class="is-tag expire" v-if="item.status == 2">过期</span>
        </div>
      </div>
      <div class="card-line">持卡人：<span style="margin-right:calc(var(--gap)*5);">{{item.storedCardName}}</span>{{item.storedCardPhone}}</div>
      <div class="card-line">余额：<span style="color:var(--c3);">{{ item.allTotalMoney | formatNumber }}</span></div>
      <div class="card-line">有效期：{{item.expireDate?(app.tool.date.formatDatetime(item.expireDate,"yyyy-MM-dd")):'不限'}}</div>
      <div class="card-line van-ellipsis">备注：{{item.remark}}</div>
    </div>
    <empty-page :show="list.length === 0 && !loading" tips="没有找到储值卡~" />
    </vx-list>
  </div>
</template>

<script>
import SearchFilterNew from "@x3/vue/comp/search-filter-new.vue";
import FilterItem from '@x3/vue/comp/filter-item.vue';
import sideFilterItem from '@x3/vue/filter-comps/side-filter.vue';
import emptyPage from '@teacher/components/empty-page.vue';

export default {
  name: 'stored-card-list',
  computed: {
    seachItems () {
      let arr = ['campus', 'search'];
      if (app.permission.op('stored_card_charge')) {
        arr.push('add')
      }
      return arr;
    },
    // 当前是否有筛选
    hasFilter: function () {
      if (this.params.openCampusIds.length > 0) {
        return true;
      } else if (this.params.studentIds.length > 0) {
        return true;
      } else if(this.params.statusList.length > 0 ){
        return true;
      } else if(this.params.phoneOrName!='' || this.params.openCardTimeStart!=='' || this.params.openCardTimeEnd!=='') {
        return true;
      } else {
        return false;
      }
    }
  },
  data() {
    return {
      pageTitle: '储值卡',
      list: [],
      totalCount: 0,
      api: this.$api.queryStoredCardAccountList,
      params: {
        openCampusIds: [app.teacher.campusId],
        openCampusList: [app.teacher.campus],
        openCardTimeStart: '',
        openCardTimeEnd: '',
        studentIds: [],
        statusList: [0],
        phoneOrName: ''
      },
      loading: true,
    };
  },
  methods: {
    onLoad(list, res) {
      vant.Toast.clear();
      this.loading = false;
      this.list = list;
      this.totalCount = res.page.totalCount;
    },
    // 打开筛选
    async openFilter() {
      let res = await app.x3.side.xsStoredCardFiltrate({
        params: this.params
      });
      this.params = Object.assign(this.params, res.params);
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.openCampusIds,
        list: this.params.openCampusList
      });
      this.params.openCampusIds = res.ids;
      this.params.openCampusList = res.list;
    },
    // 新增
    gotoAddstoredCard() {
      this.$router.push(`/prestore?type=1`);
    },
    filterChange (res) {
      Object.assign(this.params, res)
    },
  },
  created() {
    this.$onBus('refresh-stored-card-list', () => {
      this.$refs.listScroller.refresh();
    });
  },
  components: {
    SearchFilterNew,
    FilterItem,
    sideFilterItem,
    emptyPage
  }
};
</script>

<style lang="scss" scoped>
.stored-card-list {
  display: flex;
  flex-direction: column;
  .wrapper {
    flex: 1;
    overflow-y: auto;
    .card-wrap {
      margin: 0 calc(var(--gap) * 16) calc(var(--gap) * 12) calc(var(--gap) * 16);
      padding-bottom: calc(var(--gap) * 8);
      background-color: var(--white);
      border-radius: calc(var(--radius-base) * 2);
      .card-top {
        padding: calc(var(--gap) * 12) calc(var(--gap) * 16) calc(var(--gap) * 8) calc(var(--gap) * 16);
        &.expired {
          color: var(--g6);
        }
        .name {
          font-weight: bold;
        }
        .is-tag {
          font-weight: normal;
          text-align: center;
          width: calc(var(--gap) * 32);
          padding: calc(var(--gap) * 1) 0;
          font-size: var(--fs-sm);
          line-height: var(--lh-sm);
          color: var(--white);
          background-color: var(--c1);
          border-radius: calc(var(--radius-base) * 0.5);
          margin-left: calc(var(--gap) * 4);
          &.expire {
            color: var(--white);
            background-color: var(--g6);
          }
        }
      }
      .card-line {
        padding: 0 calc(var(--gap) * 16) calc(var(--gap) * 4) calc(var(--gap) * 16);
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        color: var(--g6);
      }
    }
  }
}
</style>